<template>
  <div v-bind="$attrs" :class="classes" v-on="$listeners">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseCol",
  inheritAttrs: false,
  props: {
    /** Column sizes (1–12 or `true` for auto) */
    cols: { type: [String, Number, Boolean], default: null },
    colsSm: { type: [String, Number, Boolean], default: null },
    sm: { type: [String, Number, Boolean], default: null },
    colsMd: { type: [String, Number, Boolean], default: null },
    md: { type: [String, Number, Boolean], default: null },
    colsLg: { type: [String, Number, Boolean], default: null },
    lg: { type: [String, Number, Boolean], default: null },
    colsXl: { type: [String, Number, Boolean], default: null },
    xl: { type: [String, Number, Boolean], default: null },
    colsXxl: { type: [String, Number, Boolean], default: null },
    xxl: { type: [String, Number, Boolean], default: null },
    /** Auto width (overrides cols=*) */
    auto: { type: Boolean, default: false },

    /**
     * Offsets (0–12)
     */
    offset: { type: [String, Number], default: null },
    offsetSm: { type: [String, Number], default: null },
    offsetMd: { type: [String, Number], default: null },
    offsetLg: { type: [String, Number], default: null },
    offsetXl: { type: [String, Number], default: null },
    offsetXxl: { type: [String, Number], default: null },

    /**
     * Ordering
     */
    order: { type: [String, Number], default: null },
    orderSm: { type: [String, Number], default: null },
    orderMd: { type: [String, Number], default: null },
    orderLg: { type: [String, Number], default: null },
    orderXl: { type: [String, Number], default: null },
    orderXxl: { type: [String, Number], default: null },

    /**
     * align-self: start | center | end | baseline | stretch
     */
    alignSelf: { type: String, default: null },
  },
  computed: {
    classes() {
      const cls = [];
      const add = (prefix, val) => {
        if (val === true) {
          // plain `.col-XX`
          cls.push(prefix);
        } else if (val != null && val !== false) {
          cls.push(`${prefix}-${val}`);
        }
      };

      // cols
      if (this.auto) {
        cls.push("col-auto");
      } else {
        add("col", this.cols);
        add("col-sm", this.sm ?? this.colsSm);
        add("col-md", this.md ?? this.colsMd);
        add("col-lg", this.lg ?? this.colsLg);
        add("col-xl", this.xl ?? this.colsXl);
        add("col-xxl", this.colsXxl);
      }

      // offsets
      add("offset", this.offset);
      add("offset-sm", this.offsetSm);
      add("offset-md", this.offsetMd);
      add("offset-lg", this.offsetLg);
      add("offset-xl", this.offsetXl);
      add("offset-xxl", this.offsetXxl);

      // order
      add("order", this.order);
      add("order-sm", this.orderSm);
      add("order-md", this.orderMd);
      add("order-lg", this.orderLg);
      add("order-xl", this.orderXl);
      add("order-xxl", this.orderXxl);

      // align-self
      if (this.alignSelf) {
        cls.push(`align-self-${this.alignSelf}`);
      }

      // Fallback: if no col-* class was ever added, default to `.col`
      if (!cls.some((c) => c.startsWith("col"))) {
        cls.push("col");
      }

      return cls;
    },
  },
};
</script>
